import { ReactComponent as ActeioLogo } from "../assets/brand/acteio-logo.svg";
import { fileUrl } from "../lib/api";

export default function Logo({ className = "", dark = false, brand }) {
  const name = brand?.name || "Acteio";
  const letter = (brand?.logo_letter || brand?.letter || name[0] || "A").toUpperCase();
  const logoId = brand?.logo_file_id;

  // Pas de société active → logo plateforme Acteio
  if (!brand) {
    return (
      <div className={`flex items-center ${className}`} data-testid="brand-logo">
        <ActeioLogo style={{ height: 32, width: "auto" }} />
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      {logoId ? (
        <img
          src={fileUrl(logoId)}
          alt={name}
          className="h-8 w-auto max-w-[150px] object-contain shrink-0"
        />
      ) : (
        <>
          <div className="relative flex items-center justify-center w-8 h-8 bg-primary rounded-sm shrink-0">
            <span className="text-white font-heading font-extrabold text-lg leading-none">{letter}</span>
            <span className="absolute -right-0.5 -top-0.5 w-2 h-2 bg-emerald-400 rounded-full" />
          </div>
          <span className={`font-heading font-extrabold text-xl tracking-tight ${dark ? "text-white" : "text-foreground"}`}>
            {name}
          </span>
        </>
      )}
    </div>
  );
}
